import { render, staticRenderFns } from "./KidsAppReviewRequest.vue?vue&type=template&id=43bc3579&scoped=true"
import script from "./KidsAppReviewRequest.vue?vue&type=script&lang=js"
export * from "./KidsAppReviewRequest.vue?vue&type=script&lang=js"
import style0 from "./KidsAppReviewRequest.vue?vue&type=style&index=0&id=43bc3579&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bc3579",
  null
  
)

export default component.exports